export default [
    {
        path: "feedback-lists",
        name: "FeedbackLists",
        component: () =>
            import(
                /* webpackChunkName: "AppList" */ "../pages/feedBack/Feedback.vue"
            ),
        meta: {
            title: `Feedback`,
        },
    }
];
